














































































































































































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import Order from './Order.vue';
import { GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import { GQL_allCurrencies_allCurrencies } from '@/queries/__generated__/allCurrencies';
import { SmartQuery } from 'vue-apollo-decorator';
import { parseAccountingCost } from '@/app/Order';
import { GET_CUSTOMER } from '@/queries/Customer';
import Bugsnag from '@bugsnag/js';
import { GQL_customer, GQL_customer_customer_customerContacts } from '@/queries/__generated__/customer';

@Component
export default class OrderInfo extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public order!: any;
  @Prop({ type: String, default: 'full' }) public mode!: 'full' | 'minimal';
  @Inject() public documentComponent!: Order;
  @Inject() public isRecurring!: boolean;

  @SmartQuery<OrderInfo, GQL_customer>({
    query: () => GET_CUSTOMER,
    variables() { return { id: this.order.customer.id } },
    update: data => { return data && data.customer ? data.customer.customerContacts : [] },
    skip() { return !this.editable || !this.order.customer.id },
    fetchPolicy: 'no-cache',
  }) public customerContacts!: GQL_customer_customer_customerContacts[];

  // TODO: When we have requirements to support other country invoices, implement this to be read from bankAccounts.
  public bankAccountCountryCode = 'NO';

  private showCar = this.documentComponent.displaySettings.invoiceCar || this.hasCar();
  private showProject = this.documentComponent.displaySettings.invoiceProject || this.hasProject();
  private showDepartment = this.documentComponent.displaySettings.invoiceDepartment || this.hasDepartment();

  get editable() {
    return this.documentComponent.reactiveProps.editable;
  }

  public accountingCost() {
    return parseAccountingCost(this.order.accountingCost, this.order);
  }

  public hasCar() {
    return this.editable ? !!this.order.car.id : this.accountingCost().car.present;
  }

  public hasProject() {
    return this.editable ? !!this.order.project.id : this.accountingCost().project.present;
  }

  public hasDepartment() {
    return this.editable ? !!this.order.department.id : this.accountingCost().department.present;
  }

  public setCar(car: GQL_currentUnitCars_currentUnit_cars) {
    if (!car.id) return;
    this.order.car = car;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.order.orderLines.forEach((line: any) => {
      line.car = car;
    });
    Bugsnag.leaveBreadcrumb('Car set', { car });
  }

  public unsetCar() {
    this.order.car = { id: null };
    Bugsnag.leaveBreadcrumb('Car unset');
  }

  public setProject(project: GQL_currentUnitProjects_currentUnit_projects) {
    if (!project.id) return;
    this.order.project = project;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.order.orderLines.forEach((line: any) => {
      line.project = project;
    });
    Bugsnag.leaveBreadcrumb('Project set', { project });
  }

  public unsetProject() {
    this.order.project = { id: null };
    Bugsnag.leaveBreadcrumb('Project unset');
  }

  public setDepartment(department: GQL_currentUnitDepartments_currentUnit_departments) {
    if (!department.id) return;
    this.order.department = department;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.order.orderLines.forEach((line: any) => {
      line.department = department;
    });
    Bugsnag.leaveBreadcrumb('Department set', { department });
  }

  public unsetDepartment() {
    this.order.department = { id: null };
    Bugsnag.leaveBreadcrumb('Department unset');
  }

  public setCurrency(currency: GQL_allCurrencies_allCurrencies) {
    if (!currency) return;
    this.order.currencyCode = currency.code;
    Bugsnag.leaveBreadcrumb('Currency set', { currency });
  }

  public unsetCurrency() {
    this.order.currencyCode = null;
    Bugsnag.leaveBreadcrumb('Currency unset');
  }

  public get vatText() {
    return this.order.supplierParty.vatRegulation ? this.$t('Document.vat') : '';
  }
}
